import { getResultingAspectFloat } from "../helpers/helpers";

export default function initCardsSlider() {
  const swipers = document.querySelectorAll(".js-swiper-cards");
  swipers?.forEach((block) => {
    const swipercards = new Swiper(block, {
      slidesPerView: 1.125,
      spaceBetween: 20,
      centeredSlides: true,					
      loop: true,
      preventClicks: true,
      slideToClickedSlide: true,
      breakpoints: {
        375: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2.75
        },
        992: {
          slidesPerView: 3.5,
        },
        1280: {
          slidesPerView: 5.5,
          slideToClickedSlide: false
        }
      }					
    });

    onCardsClick(block);
    let resizing;
    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => onCardsClick(block), 250);
    });
  });  
}

function onCardsClick(block) {
  const slidecards = block.querySelectorAll(".swiper-slide");
  const cards = block.querySelectorAll(".card-cont");
  let flippedCardsIndexes = [];
  cards?.forEach((card) => {
    const clone = card.cloneNode(true);
    clone.classList.remove("flipped");
    card.replaceWith(clone);       
    !window.matchMedia("(hover: hover)").matches
      && clone.addEventListener("click", (e) => handleCardClick(clone, slidecards, flippedCardsIndexes));    
    clone.style.setProperty("--min-h", `${Math.round(getResultingAspectFloat(9, 15, clone.offsetWidth))}px`);      
  });
}

function handleCardClick(clone, slidecards, flippedCardsIndexes) {
  const index = clone.parentElement.getAttribute("data-swiper-slide-index");
  const otherSlides = Array.from(slidecards)?.filter((slide) => slide.getAttribute("data-swiper-slide-index") === index);

  if (clone.classList.contains("flipped")) {
    clone.classList.remove("flipped");
    flippedCardsIndexes = flippedCardsIndexes?.filter((j) => j === index);            
    otherSlides?.forEach((slide) => slide.querySelector(".card-cont")?.classList.remove("flipped"));
  
  } else {
    !flippedCardsIndexes.includes(index)
      && flippedCardsIndexes.push(index);
    clone.classList.add("flipped");
    otherSlides?.forEach((slide) => slide.querySelector(".card-cont")?.classList.add("flipped"));
  }
}